// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgagePropertyValueUploaded } = require('components/mortgageRequest/mortgageRequestPropertyValue/mortgagePropertyValueUploaded/mortgagePropertyValueUploaded');

const MortgagePropertyValueUploadedView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgagePropertyValue-breadCrumbText'),
            url: ''
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        <div className="mortgage-property-value-uploaded-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('mortgagePropertyValue-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-offset-2 col-xs-8">
                            <MortgagePropertyValueUploaded />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

MortgagePropertyValueUploadedView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired,
}

module.exports.MortgagePropertyValueUploadedView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgagePropertyValueUploadedView);
